import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// this playlists slice is used in channels
type IChannel = {
  channelHashId: string;
  playlists: any;
};

export type allPlaylistState = {
  channels: Record<string, IChannel>; // Update type to store video objects directly within channel objects
};

const initialState: allPlaylistState = {
  channels: {}
};

const allPlaylistSlice = createSlice({
  name: 'channel-playlist-data',
  initialState: initialState,
  reducers: {
    addPlaylistsToChannel(state, action: PayloadAction<{ channelHashId: string; playlists: any }>) {
      const { channelHashId, playlists } = action.payload;
      if (!state.channels[channelHashId]) {
        state.channels[channelHashId] = {
          channelHashId: channelHashId,
          playlists: []
        };
      }
      state.channels[channelHashId].playlists = playlists?.results || [];
    },
    insertNewPlaylist(state, action: PayloadAction<{ channelHashId: string; newPlaylist: any }>) {
      const { channelHashId, newPlaylist } = action.payload;

      // If the channel exists, append the playlist; otherwise, create a new entry
      if (state.channels[channelHashId]) {
        // Append the new playlist to the existing channel's playlists array
        state.channels[channelHashId].playlists = [...state.channels[channelHashId].playlists, newPlaylist];
      } else {
        // Create a new channel entry with the new playlist
        state.channels[channelHashId] = {
          channelHashId: channelHashId,
          playlists: [newPlaylist] // Initialize playlists array with the new playlist
        };
      }
    }
  }
});

export const { addPlaylistsToChannel, insertNewPlaylist } = allPlaylistSlice.actions;

export const allPlaylistsReducers = allPlaylistSlice.reducer;
